import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/welcome.png';
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin": "100px auto"
  }
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "logo",
  alt: "logo"
})], -1);
export function render(_ctx, _cache) {
  const _component_a_card = _resolveComponent("a-card");
  return _openBlock(), _createBlock(_component_a_card, {
    bordered: false,
    style: {
      "display": "flex",
      "justify-content": "center",
      "height": "100%"
    }
  }, {
    default: _withCtx(() => [_hoisted_1]),
    _: 1
  });
}